import en1 from './en1.png'
import en2 from './en2.png'
import en3 from './en3.png'
import en4 from './en4.png'
import en5 from './en5.png'
import en6 from './en6.png'
import en7 from './en7.png'
import en8 from './en8.png'
import roysha from './roysha.jpeg'
import shreyansh from './shreyansh.jpeg'
import utkarsh from './utkarsh.jpeg'

export const asset = {
    en1,
    en2,
    en3,
    en4,
    en5,
    en6,
    en7,
    en8,
    roysha,
    shreyansh,
    utkarsh
}